/* External dependencies */
import { gql } from '@apollo/client';

/* Local dependencies */
import { setAuthenticatedClient } from '../../../../client/graphql';
import { VerifyDeviceInput, Device } from '../../types';

const VERIFY_DEVICE = gql`
  mutation VerifyDevice($input: T26VerifyDeviceInput!) {
    T26VerifyDevice(input: $input) {
      id
      address
      comment
      deviceLocation {
        lat
        lon
      }
      isVerified
      paymentService
      registrationDate
      user {
        id
      }
    }
  }
`;

const blobToBase64 = async (blobUrl: string): Promise<string> => {
  const response = await fetch(blobUrl);
  const blob = await response.blob();
  
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result as string;
      const base64Data = base64String.split(',')[1];
      resolve(base64Data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const verifyDeviceRequest = async (input: VerifyDeviceInput): Promise<Device> => {
  try {
    let imageData = input.image;
    if (input.image.startsWith('blob:')) {
      imageData = await blobToBase64(input.image);
    }

    const cleanInput = {
      ...input,
      image: imageData,
      deviceLocation: {
        lat: input.deviceLocation.lat,
        lon: input.deviceLocation.lon
      },
      userLocation: {
        lat: input.userLocation.lat,
        lon: input.userLocation.lon
      }
    };

    const client = await setAuthenticatedClient();
    const response = await client.mutate({
      mutation: VERIFY_DEVICE,
      variables: { input: cleanInput },
    });
    return response.data.T26VerifyDevice;
  } catch (err) {
    console.error('Error verifying device:', err);
    throw err;
  }
};
